var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebcam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.622 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.452,36.981,15.7,34.062a7.269,7.269,0,0,1-10.818,0L3.132,36.981a1.043,1.043,0,0,0,1.081,1.563l6.079-1.105,6.079,1.105a1.067,1.067,0,0,0,.192.018,1.044,1.044,0,0,0,.889-1.581Z",
    transform: "translate(-2.981 -22.563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.609,1a6.609,6.609,0,1,0,6.609,6.609A6.616,6.616,0,0,0,11.609,1Zm0,10.783A3.478,3.478,0,1,1,15.087,8.3,3.478,3.478,0,0,1,11.609,11.783Z",
    transform: "translate(-4.297 -1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.333,
    cy: 1.333,
    r: 1.333,
    transform: "translate(5.978 5.942)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebcam);
export default __webpack_public_path__ + "static/media/Icon_Webcam.169310a5a91a890e76961b54d1d1d43d.svg";
export { ForwardRef as ReactComponent };